// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Event, MailboxSettings, ScheduleInformation } from '@microsoft/microsoft-graph-types';
import { Observable } from 'rxjs';

// Import project-specific dependencies
import { GraphApiService } from '@app/services/graph-api.service';
import { environment } from '@app/environments/environment';
import { CALENDAR_EVENTS_SERVICE_CONSTS } from '@app/config/constants';
import { IGraphApiResponse } from '@app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class CalendarEventsService extends GraphApiService {
  consts = CALENDAR_EVENTS_SERVICE_CONSTS;

  API_URL = `${environment.GRAPH.URL}/${environment.GRAPH.VERSIONS.V1}`;

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  getCalendarEvents(timezone: string, startDateTime: string, endDateTime: string): Observable<Event[]> {
    const url = `${this.API_URL}/me/calendarview`;
    const parameters = {
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      $orderby: this.consts.QUERY_ORDER_BY
    };
    const headers = {
      ConsistencyLevel: this.consts.HEADER_CONSISTENCY_LEVEL,
      Prefer: `outlook.timezone="${timezone}"`
    };
    return this.getData(url, parameters, headers);
  }

  getEmailSettings(): Observable<MailboxSettings> {
    return this.get<MailboxSettings>(`${this.API_URL}/me/mailBoxSettings`);
  }

  getScheduleByUserEmail(mail: string[]): Observable<IGraphApiResponse> {
    const scheduleInformation = {
      schedules: mail,
      startTime: {
        dateTime: this.consts.QUERY_SCHEDULE_START_DATETIME,
        timeZone: this.consts.QUERY_SCHEDULE_TIMEZONE
      },
      endTime: {
        dateTime: this.consts.QUERY_SCHEDULE_END_DATETIME,
        timeZone: this.consts.QUERY_SCHEDULE_TIMEZONE
      },
      availabilityViewInterval: 60
    };
    return this.post<IGraphApiResponse>(`${this.API_URL}/me/calendar/getschedule`, scheduleInformation);
  }
}
